import Nav from "react-bootstrap/Nav";

const NavLink = ({ label, onClick, styles }) => (
  <Nav.Link
    onClick={onClick}
    style={{ color: "rgba(0, 0, 0, 0.8)", width: "max-content", ...styles }}
  >
    <h6>{label}</h6>
  </Nav.Link>
);

export default NavLink;
